import angular from 'angular';

import GroupsButtonService from './GroupsButtonService';
import GroupsTree from './GroupsTreeBranchDirective';
import GroupsTreeRootComponent from './GroupsTreeRootComponent';
import GroupsButtonComponent from './GroupsButtonComponent';

export default angular
  .module('petroCloud.base.groupsButton', [])
  .service('GroupsButtonService', GroupsButtonService)
  .directive('groupsTreeBranch', GroupsTree)
  .component(GroupsTreeRootComponent.name, GroupsTreeRootComponent)
  .component(GroupsButtonComponent.name, GroupsButtonComponent)
  .name;
